import React from 'react';

import uuid from 'uuid';

import { StyledGenderOrAgesPerformance } from './style/StyledGenderOrAgesPerformance';

import NotFound from '../NotFound';

import DynamicComponent from '../../DynamicComponent';

const GenderOrAgesPerformance = ({ data, channel, isLast }) => (
	<StyledGenderOrAgesPerformance channel={channel}>
		<section>
			<h2>{data.title}</h2>
			<p>{data.content.text}</p>
		</section>

		{
			data.charts.length > 0 ? (
				<div className="content-1200">
					<div className="content-charts">
						{data.charts.map(chart => (
							<DynamicComponent
								tag={chart.type}
								data={chart.data}
								captions={chart.captions}
								typeChart="GenderOrAgesPerformance"
								channel={channel}
								key={uuid.v4()}
							/>
						))}
					</div>
				</div>
			) : (
				<section className="mt-4">
					<NotFound />
				</section>
				)
		}

		{!isLast ? <hr /> : null}
	</StyledGenderOrAgesPerformance>
);

export default GenderOrAgesPerformance;
